import type {PointerEventHandler} from 'react'

export const preventNonMouseEvent: PointerEventHandler<HTMLElement> = (event) => {
  if (event.pointerType !== 'mouse') {
    event.stopPropagation()
  }
}
